import {trackPromise} from "react-promise-tracker";
import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {isEmpty} from "lodash";

export const getCustomers = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("getCustomers");
  return trackPromise(Call.get(url));
};

export const getCustomersLabelValueAsync = () => {
  const url = getUrl("getCustomersLabelValue");
  return trackPromise(Call.get(url));
};

export const sendCustomerData = (data) => {
  const {id = ""} = data;
  const url = getUrl("getCustomers");
  if (!isEmpty(id.toString())) {
    const patchUrl = `${url}${id}/`;
    return trackPromise(Call.patch(patchUrl, data));
  } else {
    return trackPromise(Call.post(url, data));
  }
};
